var data, prevData, height = 0,	counter = 0, dataCount = 0;

$(document).ready(function() {

	if ($('[data-component="menu"]').length) {
		var menu = new Menu();
	}

	if ($('[data-component="libraries-list"]').length) {
		var librariesList = new LibrariesList();
	}

	if ($('[data-page="areas-detalhe"]').length) {
		var areasDetalhe = new AreasDetalhe();
	}

	if ($('[data-page="vagas"]').length) {
		var vagas = new Vagas();
	}

	if ($('[data-component="login-block"]').length) {
		var login = new Login();
	}

	if ($('[data-component="birthday-message"]').length) {
		var birthdayMessage = new BirthdayMessage();
	}

	if ($('[data-component="accordion"]').length) {
		var accordion = new Accordion();
	}

	// if ($('[data-component="structure"]').length) {
	// 	var structure = new Structure();
	// }

	if ($('[data-component="timeline"]').length) {
		var timeline = new Timeline();
	}

	$('.select').each(function() {
		$(this).find('span').text($(this).find('.custom-select option:selected').text());
	});

	$('.custom-select').on('change', function() {
		$(this).prev('span').text($(this).find('option:selected').text());
	});

	if ('[data-page="login"]') {

		if ($(window).width() > 768) {
			$("html, body").css('height', '100%');
		} else {
			if ($(window).height() > 600) {
				$("html, body").css('height', '100%');
			} else {
				$("html, body").css('min-height', '100%');
				$('[data-component="login-block"]').addClass('scroll');
			}
		}
	}

	if ($('[data-equalizer]').length) {
		if($(window).width() >= 768) {
			$('[data-equalizer]').each(function(e) {
				data = $(this).attr('data-equalizer');
				if (counter < 1) {
					prevData = data;
					counter++;
				}
				if (data === prevData) {
					dataCount++;
					calculateHeight($(this), data);
				} else {
					counter = 0;
					height = 0;
					prevData = '';
					calculateHeight($(this), data);
				}
				if (dataCount === $('[data-equalizer="' + data + '"]').length) {
					$('[data-equalizer="' + data + '"] > div').height(height);
					// dataCount = 0;
				}
			});
		}
	}

	$('.icon-star').on('click', function(){
		$(this).toggleClass('favorite');
	})

	if ($('table').length > 0) {
		$('table').each(function() {
			$(this).wrap('<div class="overlay"></div>')
		});
	}

});

function calculateHeight(item, data) {
	console.log(height);

	if (item.height() > height) {
		height = item.outerHeight();
	}
}

$(window).on('load', function() {
	if ($('.scrollbar-inner').length) {
		if( $('.scrollbar-inner').closest('.modal').length > 0 ) {
			$('.scrollbar-inner').mCustomScrollbar({
				axis:"yx"
			});
		} else {
			$('.scrollbar-inner').mCustomScrollbar();
		}
	}
});
